<template>
  <v-col>
    <v-row>
      <!-- mini statistic start -->
      <v-col :cols="6" :sm="12" :lg="6">
        <SkillCategoriesTable />

        <AoTypesTable
          class="mt-5"
          v-if="
            ['ADMIN', 'SUPERADMIN'].includes(current_user.role) ||
            current_user.is_admin
          "
        />
      </v-col>
      <v-col :cols="6" :sm="12" :lg="6">
        <SkillsTable />
      </v-col>
    </v-row>
    <v-row
      v-if="
        ['ADMIN', 'SUPERADMIN'].includes(current_user.role) ||
        current_user.is_admin
      "
    >
      <!-- mini statistic start -->
      <v-col :cols="6" :sm="12" :lg="6">
        <SquadTable />
      </v-col>
      <v-col :cols="6" :sm="12" :lg="6"> <LogoForm /></v-col>
    </v-row>
  </v-col>
</template>

<script>
import AoTypesTable from "@/components/card/AoTypeTable"
import SquadTable from "@/components/card/SquadTable"
import LogoForm from "@/components/card/LogoForm"
import SkillsTable from "@/components/card/SkillsTable"
import SkillCategoriesTable from "@/components/card/SkillCategoriesTable"

export default {
  components: {
    SkillCategoriesTable,
    SkillsTable,
    LogoForm,
    SquadTable,
    AoTypesTable,
  },
  computed: {
    current_user() {
      return this.$store.state.user.profile
    },
  },
  methods: {},
}
</script>
